export const INTERACTION_ID = "posapp";
